module.exports = __webpack_public_path__ + "img/simpra-slider2.7fb19458.webp";